
import { defineComponent } from "vue";
import CodeHighlighter from "@/components/highlighters/CodeHighlighter.vue";
import { code5 } from "@/views/resources/documentation/element-ui/basic/space/code";

export default defineComponent({
  name: "auto-wrapping",
  components: {
    CodeHighlighter
  },
  setup() {
    return {
      code5
    };
  }
});
